import { FC, useEffect, useState } from 'react'
import {
  StylePreviewWrapper,
  StyleImageWrapper,
  StyleImage,
  StylePreviewCloseAction,
  StylePreviewRow,
} from './style'
import Svg from '@components/svg'
import download from '@utils/download'
import downloadBase64File from '@utils/downloadBase64File'
import { Constant } from '@utils'
import useWindowSize from '@hooks/useWindow'
interface PreviewProps {
  file: any
  onClose?: () => void
}
const Preview: FC<PreviewProps> = ({ file, onClose }) => {
  const extension = file?.extension || file?.split('.').pop()
  const { width, height } = useWindowSize()
  return (
    <StylePreviewWrapper>
      <StylePreviewRow>
        <StylePreviewCloseAction
          onClick={async () => {
            if (!!file?.base64) {
              await downloadBase64File(
                file?.base64,
                file?.fileName,
                file?.extension,
              )
            } else {
              await download(file)
            }
          }}
        >
          <Svg svg={'download'} color={'white'} />
        </StylePreviewCloseAction>
        <StylePreviewCloseAction
          bg={'danger'}
          onClick={() => {
            onClose && onClose()
          }}
        >
          <Svg svg={'closeSVGIcon'} color={'white'} />
        </StylePreviewCloseAction>
      </StylePreviewRow>
      <StyleImageWrapper>
        {!!Constant?.imageValidationExtensions?.includes(extension) ? (
          <StyleImage
            src={file?.base64 ? `${file?.info},${file?.base64}` : file}
          />
        ) : (
          <iframe
            src={!!file?.base64 ? `${file?.info},${file?.base64}` : file}
            width={width / 2}
            height={height / 1.5}
          />
        )}
      </StyleImageWrapper>
    </StylePreviewWrapper>
  )
}

export default Preview
